module.exports = __webpack_public_path__ + "static/metaimage-4da842bb8c2c177a7a209b86baba69ab.png";